import { render, staticRenderFns } from "./NewEvaluationView.vue?vue&type=template&id=2606e034&scoped=true"
import script from "./NewEvaluationView.vue?vue&type=script&lang=js"
export * from "./NewEvaluationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2606e034",
  null
  
)

export default component.exports